export const cleanObject = <T extends Record<string, any>>(obj: T): Record<string, unknown> => {
  const result: Record<string, unknown> = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      const isEmpty =
        value === "" ||
        value === null ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0);

      if (!isEmpty) {
        result[key] = value;
      }
    }
  }

  return result;
};
